import { Button } from "@mui/material";
import auctionLogo from "../../components/assets/auction.svg";
import theme from "../../theme";
import { useTranslation } from "react-i18next";

const PreviousAuctionsButton = ({
  onClick
}) => {

  const { t } = useTranslation("liveAuction")

  return (
    <Button
      variant="contained"
      fullWidth
      startIcon={<img src={auctionLogo} />}
      sx={{
        borderRadius: "0.5rem",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.text.secondary,
        textTransform: "none",
        fontWeight: 500,
        padding: "0.85rem 1rem",
        fontSize: "0.95rem",
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
      }}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
        // setViewAuctionBidHistory(true);
      }}
    >
      {t(`Previous Auctions`)}
    </Button>
  )
};

export default PreviousAuctionsButton;